module.exports = __webpack_public_path__ + "static/media/isIFR.efcaddc9.png";